/** Visible-card recommendation measurement and consent-aware session context.
 * Signed decisions distinguish ranked products from theme/catalog fallbacks.
 * Only verified cart responses and paid-order webhooks supply outcome evidence. */
(function () {
  'use strict';
  if (window.__mmRecsFeedbackInit) return;
  window.__mmRecsFeedbackInit = true;
  var ENDPOINT = '/apps/garden/v1/recommendations/feedback';
  var queue = [], sending = false, timer = null;
  var cards = new WeakMap();
  var session = null;
  function allowed() {
    try { return Boolean(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed()); } catch (_) { return false; }
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    if (window.crypto && crypto.getRandomValues) { var a = new Uint32Array(4); crypto.getRandomValues(a); return Array.from(a).map(function(n){ return n.toString(16).padStart(8, '0'); }).join(''); }
    return null;
  }
  function sessionId() {
    if (!allowed()) return null;
    if (session) return session;
    try { var saved = JSON.parse(localStorage.getItem('mm-recs-v3-session') || 'null'); session = saved && saved.expires > Date.now() ? saved.id : uuid(); if (session) localStorage.setItem('mm-recs-v3-session', JSON.stringify({id:session,expires:Date.now()+30*60*1000})); } catch (_) { session = uuid(); }
    return session;
  }
  var privacyState = 'loading';
  var privacyReady = new Promise(function(resolve) {
    var settled = false;
    function finish() {
      if (settled) return;
      settled = true;
      privacyState = window.Shopify && Shopify.customerPrivacy ? 'ready' : 'unavailable';
      if (privacyState === 'unavailable') console.warn('[Recommendations] Consent API unavailable; measurement is disabled.');
      resolve();
    }
    if (window.Shopify && Shopify.customerPrivacy) return finish();
    setTimeout(finish, 1000);
    try {
      if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
        Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], finish);
      } else finish();
    } catch (_) { finish(); }
  });
  var experimentLink = Promise.resolve();
  var linkedSession = null;
  async function persistExperiment(token) {
    if (!allowed() || !token) return;
    experimentLink = experimentLink.catch(function(){}).then(async function(){
      if (!allowed()) return;
      var context = decisionData(token); if (!context) return;
      var stored; try { stored=JSON.parse(localStorage.getItem('mm-recs-v3-experiment') || 'null'); } catch(_) {}
      if (linkedSession === context.session && stored && stored.session === context.session && stored.acknowledged && stored.expires > Date.now()+3600000) return;
      var enrollment = await window.fetch(ENDPOINT,{method:'POST',credentials:'same-origin',keepalive:true,headers:{'Content-Type':'application/json'},body:JSON.stringify({experimentToken:token})});
      if (!enrollment.ok || !allowed()) return;
      var linked = await window.fetch('/cart/update.js',{method:'POST',credentials:'same-origin',keepalive:true,headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{__garden_rec_experiment:token}})});
      if (!linked.ok) return;
      try { localStorage.setItem('mm-recs-v3-experiment',JSON.stringify({session:context.session,expires:context.expires,acknowledged:false})); } catch(_) {}
      var acknowledged = await window.fetch(ENDPOINT,{method:'POST',credentials:'same-origin',keepalive:true,headers:{'Content-Type':'application/json'},body:JSON.stringify({experimentToken:token,cartLinked:true})});
      if (acknowledged.ok) linkedSession = context.session;
      if (acknowledged.ok) try { localStorage.setItem('mm-recs-v3-experiment',JSON.stringify({session:context.session,expires:context.expires,acknowledged:true})); } catch(_) {}
    });
    await experimentLink.catch(function(){});
  }
  function clearConsentState() {
    queue=[];session=null;linkedSession=null;
    var linked=false;
    try { linked=Boolean(localStorage.getItem('mm-recs-v3-experiment'));localStorage.removeItem('mm-recs-v3-experiment');localStorage.removeItem('mm-recs-v3-session');sessionStorage.removeItem('mm-recs-v3-click'); }catch(_){}
    if(linked) experimentLink.finally(function(){return window.fetch('/cart/update.js',{method:'POST',credentials:'same-origin',keepalive:true,headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{__garden_rec_experiment:''}})});}).catch(function(){});
  }
  privacyReady.then(function(){if(!allowed())clearConsentState();});
  var pdpRequests = Promise.resolve();
  var reservedProducts = new Map();
  window.MrMapleRecommendations = {
    measurementStatus: function() {
      return window.Shopify && Shopify.customerPrivacy ? (allowed() ? 'allowed' : 'denied') : privacyState;
    },
    attributeCartItems: function(items) {
      var item = attribution();
      if (!Array.isArray(items) || items.length !== 1 || !matchesVariant(item, items[0].id)) return items;
      return [Object.assign({}, items[0], {properties:Object.assign({}, items[0].properties,
        {_garden_rec:item.token, _garden_rec_exposure:item.exposureId})})];
    },
    recordCartAdd: recordCartAdd,
    fetch: function(input, init) {
      var requestUrl = new URL(input, location.origin);
      var isRecommendations = requestUrl.origin === location.origin && requestUrl.pathname === '/apps/garden/v1/recommendations';
      async function capture(response, railKey) {
        if (response.ok && isRecommendations) {
          try {
            var data = await response.clone().json();
            void persistExperiment(data.experimentToken);
            if (railKey) reservedProducts.set(railKey, (data.recommendations || []).slice(0, railKey === "discovery" ? 10 : Number(requestUrl.searchParams.get("limit") || 5)).map(function(p) {
              return p.productId && String(p.productId);
            }).filter(Boolean));
          } catch (_) {}
        }
        return response;
      }
      if (!isRecommendations || !/^\/products\//.test(location.pathname) || requestUrl.searchParams.get('variant') !== 'pdp') {
        return window.fetch(input, init).then(function(response) { return capture(response); });
      }
      var run = pdpRequests.then(async function() {
        var railKey = requestUrl.searchParams.get('strategy') === 'contextual' ? 'related' : 'discovery';
        var others = [];
        reservedProducts.forEach(function(ids, key) { if (key !== railKey) others = others.concat(ids); });
        var excluded = (requestUrl.searchParams.get('exclude') || '').split(',').filter(Boolean);
        requestUrl.searchParams.set('exclude', Array.from(new Set(excluded.concat(others))).slice(0, 100).join(','));
        return capture(await window.fetch(requestUrl.toString(), init), railKey);
      });
      pdpRequests = run.catch(function() {});
      return run;
    },
    cacheKey: function(){ return sessionId() || "untracked"; },
    url: async function(input) {
      await privacyReady;
      var url = new URL(input, location.origin); var id = sessionId();
      if (id) url.searchParams.set('recSession', id);
      if (url.searchParams.get('strategy') === 'personalized-home' && !url.searchParams.has('variant') && /^\/products\//.test(location.pathname)) {
        url.searchParams.set('variant', 'pdp');
        var exclusions = Array.from(document.querySelectorAll('.mm-contextual-card[data-rec-product-id]')).map(function(c){ return c.getAttribute('data-rec-product-id'); });
        if (exclusions.length) url.searchParams.set('exclude', exclusions.slice(0,100).join(','));
      }
      if (url.searchParams.get('variant') === 'pdp' && /^\/products\//.test(location.pathname)) {
        try { url.searchParams.set('productHandle', decodeURIComponent(location.pathname.split('/').filter(Boolean).pop())); } catch (_) {}
      }
      return url.toString();
    },
    decorate: function(card, product) {
      if (card && product && product.decisionToken) card.setAttribute('data-rec-decision', product.decisionToken);
    }
  };
  function enqueue(entry) {
    if (!allowed() || !entry.exposureId || queue.length >= 200) return;
    queue.push(entry); if (!timer) timer = setTimeout(flush, 1200);
  }
  async function flush() {
    clearTimeout(timer); timer = null;
    if (sending || !queue.length) return;
    if (!allowed()) { queue = []; return; }
    sending = true;
    var batch = queue.splice(0, 8);
    try {
      var response = await fetch(ENDPOINT, { method:'POST', credentials:'same-origin', keepalive:true,
        headers:{'Content-Type':'application/json'}, body:JSON.stringify({ events:batch }) });
      if (!response.ok && (response.status >= 500 || response.status === 429)) throw new Error('retry');
    } catch (_) {
      batch.reverse().forEach(function(e){ e.attempt = (e.attempt || 0) + 1; if (e.attempt < 3) queue.unshift(e); });
    } finally { sending = false; if (queue.length) timer = setTimeout(flush, 1500); }
  }
  function record(card, event) {
    var state = cards.get(card); if (!state) return;
    if (state[event]) return;
    state[event] = true;
    var token = card.getAttribute('data-rec-decision');
    if (token) enqueue({ token:token, exposureId:state.id, event:event, observedSlot: Array.from(card.parentElement.children).filter(function(c){return c.matches('[data-rec-decision], [data-mm-rec-surface][data-rec-product-id], [data-mm-rec-surface][data-mm-rec-product-id]');}).indexOf(card)+1 });
    else enqueue({ exposureId:state.id, event:event, productGid:card.getAttribute('data-rec-product-id') || card.getAttribute('data-mm-rec-product-id'),
      surface:card.getAttribute('data-mm-rec-surface'), source:card.getAttribute('data-rec-source') || 'theme-fallback' });
  }
  var observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function(entries) {
    entries.forEach(function(entry){
      var state = cards.get(entry.target); if (!state) return;
      clearTimeout(state.timer);
      state.visible = entry.isIntersecting && entry.intersectionRatio >= .5;
      if (state.visible && !state.impression && document.visibilityState === 'visible') {
        state.timer = setTimeout(function(){
          if (state.visible && entry.target.isConnected && document.visibilityState === 'visible' && allowed()) record(entry.target, 'impression');
        }, 1000);
      }
    });
  }, { threshold:[0,.5,1] }) : null;
  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    var list = Array.from(root.querySelectorAll('[data-rec-decision], [data-mm-rec-surface][data-rec-product-id], [data-mm-rec-surface][data-mm-rec-product-id]'));
    if (root.matches && root.matches('[data-rec-decision], [data-mm-rec-surface][data-rec-product-id], [data-mm-rec-surface][data-mm-rec-product-id]')) list.push(root);
    list.forEach(function(card){
      if (cards.has(card)) return;
      cards.set(card, {id:uuid(), visible:false});
      if (observer) observer.observe(card);
    });
  }
  var mutation = new MutationObserver(function(changes){
    changes.forEach(function(change){ if (change.type === 'attributes') scan(change.target); else change.addedNodes.forEach(scan); });
  });
  mutation.observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['data-rec-decision','data-rec-product-id','data-mm-rec-product-id']});
  scan(document);
  document.addEventListener('visibilitychange', function(){
    document.querySelectorAll('[data-rec-decision], [data-mm-rec-surface][data-rec-product-id], [data-mm-rec-surface][data-mm-rec-product-id]').forEach(function(card){
      var state = cards.get(card); if (!state) return; clearTimeout(state.timer);
      if (document.visibilityState === 'visible' && observer) { observer.unobserve(card); observer.observe(card); }
    });
    if (document.visibilityState === 'hidden') flush();
  });
  document.addEventListener('visitorConsentCollected', function(){
    if (!allowed()) clearConsentState();
    else { document.querySelectorAll('[data-rec-decision], [data-mm-rec-surface][data-rec-product-id], [data-mm-rec-surface][data-mm-rec-product-id]').forEach(function(c){ if (observer) { observer.unobserve(c); observer.observe(c); } }); }
  });
  document.addEventListener('click', function(event){
    var target = event.target instanceof Element ? event.target : null;
    var link = target && target.closest('a[href]'); var card = target && target.closest('[data-rec-decision], [data-mm-rec-surface][data-rec-product-id], [data-mm-rec-surface][data-mm-rec-product-id]');
    if (!link || !card || !allowed()) return;
    scan(card); record(card, 'click');
    var state = cards.get(card); if (!state || !state.id || !card.getAttribute('data-rec-decision')) return;
    var url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || !url.pathname.startsWith('/products/')) return;
    try { sessionStorage.setItem('mm-recs-v3-click', JSON.stringify({ token:card.getAttribute('data-rec-decision'), exposureId:state.id,
      path:url.pathname, expires:Date.now()+7*86400000 })); } catch (_) {}
    flush();
  }, true);
  function attribution() {
    if (!allowed()) return null;
    try { var item = JSON.parse(sessionStorage.getItem('mm-recs-v3-click') || 'null'); return item && item.path === location.pathname && item.expires > Date.now() ? item : null; } catch (_) { return null; }
  }
  function decisionData(token) {
    try { return JSON.parse(atob(token.split('.')[0].replace(/-/g,'+').replace(/_/g,'/'))); } catch (_) { return null; }
  }
  function matchesVariant(item, variantId) {
    var decision = item && decisionData(item.token);
    return decision && Array.isArray(decision.variantIds) && decision.variantIds.indexOf(String(variantId || '').split('/').pop()) >= 0;
  }
  function isCartForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    try {
      var url = new URL(form.action, location.origin);
      return url.origin === location.origin && /\/cart\/add(?:\.js)?$/.test(url.pathname);
    } catch (_) { return false; }
  }
  // Keep theme serializers that read form.elements compatible with native forms.
  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!isCartForm(form)) return;
    var variant = form.elements.namedItem('id');
    var item = attribution();
    var valid = matchesVariant(item, variant && variant.value);
    [['properties[_garden_rec]', valid && item.token], ['properties[_garden_rec_exposure]', valid && item.exposureId]].forEach(function(pair) {
      var field = form.elements.namedItem(pair[0]);
      if (!pair[1]) { if (field && field.remove) field.remove(); return; }
      if (!field) { field = document.createElement('input'); field.type='hidden'; field.name=pair[0]; form.appendChild(field); }
      field.value=pair[1];
    });
  }, true);
  // FormData also covers native submissions and theme handlers which serialize forms.
  document.addEventListener('formdata', function(event) {
    if (!isCartForm(event.target)) return;
    var data = event.formData;
    data.delete('properties[_garden_rec]');
    data.delete('properties[_garden_rec_exposure]');
    var item = attribution();
    if (!matchesVariant(item, data.get('id'))) return;
    data.set('properties[_garden_rec]', item.token);
    data.set('properties[_garden_rec_exposure]', item.exposureId);
  }, true);
  // Called only after the cart integration receives Shopify's successful add response.
  function recordCartAdd(data) {
    if (!allowed() || !data) return;
    var rows = Array.isArray(data.items) ? data.items : [data];
    rows.forEach(function(row) {
      var properties = row.properties || {};
      var decision = decisionData(properties._garden_rec || '');
      if (properties._garden_rec_exposure && decision &&
          decision.productGid === 'gid://shopify/Product/' + row.product_id) {
        enqueue({token:properties._garden_rec, exposureId:properties._garden_rec_exposure, event:'cart_add'});
      }
    });
  }
  document.addEventListener('product-form:submit:success', function(event) {
    recordCartAdd(event.detail && event.detail.response);
  });
  window.addEventListener('pagehide', flush);
})();
